import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AgencygetLoggedUserDetails,
  getLoggedAgencyDetails,
} from "../../../redux/actions";
import { getAdminUserId, getAgencyId } from "../../common/CommonFunctions";
import Sidebar from "./Sidebar";
export default function AgencyLayout() {
  const dispatch = useDispatch();
  const [brandlogo, setProfile] = useState();
  const details = useSelector((state) => state.AgencyDetailsReducer);
 

  useEffect(() => {
    const { agencyLogo = "" } = details;

    setProfile(agencyLogo);
  }, [details]);

  useEffect(() => {
    dispatch(AgencygetLoggedUserDetails(getAdminUserId()));
  }, [getAdminUserId()]);
  useEffect(() => {
    dispatch(getLoggedAgencyDetails(getAgencyId()));
  }, [getAgencyId()]);
  return (
    <Fragment>
      <Sidebar brandlogo={brandlogo} />

         </Fragment>
  );
}
